import { useLocation } from 'react-router';
import { Box } from '@/components/Box/Box';
import StepperNotificationIcon from './images/StepperNotificationIcon.svg?react';
import { Tooltip } from '@/components/Tooltip/Tooltip';
import { isActiveRoute } from '@/bundle/Sidebar/helpers/helpers';
import { getSignUpPath } from '../../SignUpPage/path';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { getAdminSetPasswordPath } from '@/bundle/Auth/AdminOnboardingFlow/AdminSetPasswordPage/path';

export const TrialDashboardStepperTitle = () => {
  const { pathname } = useLocation();
  const { isMobile } = useResponsiveDevice();

  const showTooltipRoute = isMobile ? getAdminSetPasswordPath() : getSignUpPath();
  const isActiveShowTooltipRoute = isActiveRoute(pathname, [showTooltipRoute]);

  return (
    <Box display='flex' gap='6px' alignItems='center'>
      Launch Dashboard
      <StepperNotificationIcon data-tooltip-id='upgrade-subscription-tooltip' />
      <Tooltip id='upgrade-subscription-tooltip' defaultIsOpen={isActiveShowTooltipRoute} clickable>
        You can activate your subscription from the dashboard.
      </Tooltip>
    </Box>
  );
};
